export const enum ErrorCodeEnum {
    messagWhitelist = 'message.whitelist',
    certificateIdAlreadyExist = 'certificate.id',
    creditPOA = 'credit.POA',
    creditAria = 'credit.aria',
    creditMessage = 'credit.message',
    creditEvent = 'credit.event',
    creditCertificate = 'credit.certificate',
    creditUpdate = 'credit.update',
    approveStore ='approve.store',
    isRequestable ='token.requestable',
    alreadyKnown ='transaction.alreadyKnown',
    tooLowToCompete ='transaction.tooLowToCompete',
    nonceTooLow ='transaction.nonceTooLow',

}
